import Swiper, {Navigation, Pagination, Thumbs, EffectFade, Keyboard} from 'swiper';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

window.addEventListener("load", function () {
    const swiperNav = new Swiper('.image-slider-with-thumbnails-carousel', {
        modules: [Navigation, Pagination, Thumbs],
        spaceBetween: 5,
        slidesPerView: 4,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: "#swiper-carousel-next",
            prevEl: "#swiper-carousel-prev",
        },
        breakpoints: {
            800: {
                slidesPerView: 6
            },
            1200: {
                slidesPerView: 8
            },
            1600: {
                slidesPerView: 18
            },
            2400: {
                slidesPerView: 24
            }
        }
    });

    const swiper = new Swiper('.image-slider-with-thumbnails', {
        modules: [Navigation, Pagination, Thumbs, EffectFade, Keyboard],
        spaceBetween: 10,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: "#swiper-next",
            prevEl: "#swiper-prev",
        },
        thumbs: {
            swiper: swiperNav,
        },
        keyboard: {
            enabled: true
        }
    });
});
document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.image-slider-with-thumbnails .swiper-slide');
    slides.forEach(function (slide) {
        slide.classList.remove('d-none');
        slide.classList.add('d-flex');
    });

    const thumbnails = document.querySelectorAll('.image-slider-with-thumbnails-carousel .swiper-slide');
    thumbnails.forEach(function (thumbnail) {
        thumbnail.classList.remove('d-none');
    });
});